// React & DB Stuff
import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { UserContext } from "./UserContext";
import firebase from "firebase";
import base from "../base";
// UI
import Loading from "./Loading";
import NavBar from "./NavBar";
// Route Components
import Upload from "./Upload/components/Upload";
import DRD from "./DRD/components/DRD";
import RangeTrainer from "./RangeTrainer/components/RangeTrainer";
import TrainingData from "./TrainingData/components/TrainingData";
import Settings from "./Settings/components/Settings";
import Feedback from "./Feedback";
import Subscribe from "./Auth/components/Subscribe";
import SubscribeSuccess from "./Auth/components/SubscribeSuccess";
import MyAccount from "./Account/components/MyAccount";
import TrialModal from "./Auth/TrialModal";
// Login/authentication
import Splash from "./Splash";
import { getDate } from "../helpers";
import updateSubscriptionStatus from "./Auth/functions/updateSubscriptionStatus";
import getStripeCustomerID from "./Auth/functions/getStripeCustomerID";
import resolveUserAccess from "./Auth/functions/resolveUserAccess";
// Admin functions
import getUserLastLogin from "./Admin/getUserLastLogin";
import getTreeNamesAndIDs from "./Admin/getTreeNamesAndIDs";
import verifyUser from "./Admin/verifyUser";
import addTreeToUser from "./Admin/addTreeToUser";
import removeTreeFromUser from "./Admin/removeTreeFromUser";
import "normalize.css";
import verifyBasicUser from "./Admin/verifyBasicUser";
import deleteTree from "./Admin/deleteTree";
import sendVerificationRequest from "./VerificationRequest";
class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			userIsLoggedIn: false,
			subscriptionStatus: null,
			access: false,
			tier: null,
			trialUser: null,
			userInfo: {
				name: null,
				uid: null,
			},
			currentTrees: [],
		};
	}

	async componentDidMount() {
		firebase.auth().onAuthStateChanged(async (user) => {
			console.log("user", user);
			firebase.analytics().logEvent("login");
			if (user) {
				// get user info from database
				let userInfo = {};
				await base.fetch(`users/${user.uid}`, { context: this }).then((data) => (userInfo = data));
				console.log("userInfo", userInfo);
				// if there is no previous login, it's their first login - set trial end timestamp and other user info
				let firstLogin = false;
				if (!Object.hasOwn(userInfo, "lastLogin")) {
					firstLogin = true;
					base.post(`users/${user.uid}/trialEnd`, { data: Date.now() + 7 * 24 * 60 * 60 * 1000 });
					base.post(`users/${user.uid}/firstLoginDomain`, { data: window.location.hostname });
					base.update(`userList`, { data: { [user.uid]: user.displayName } });
					// sendVerificationRequest(user.uid, user.displayName);
				}
				base.update(`users/${user.uid}`, {
					data: { name: user.displayName, email: user.email, uid: user.uid, lastLogin: getDate() },
				});

				const userIsVerified = !!userInfo.verified;

				// VIP users bypass Stripe; everyone else gets a subscription check
				let stripeCustomerID = userInfo?.stripeCustomerID;
				if (!stripeCustomerID && !userIsVerified) {
					const fetchedCustomerID = await getStripeCustomerID(user.email);
					console.log("stripeCustomerID as fetchedCustomerID from be", fetchedCustomerID);
					if (fetchedCustomerID) {
						stripeCustomerID = fetchedCustomerID;
						base.post(`users/${user.uid}/stripeCustomerID`, { data: stripeCustomerID });
					}
				}
				const subscriptionStatusObject = await updateSubscriptionStatus(stripeCustomerID, this.handleSubscriptionStatusUpdate);
				const planType = subscriptionStatusObject.planType || userInfo?.planType;

				let treePermissions;
				await base.fetch(`treePermissions/${user.uid}`, { context: this }).then((tpData) => (treePermissions = tpData));

				const accessState = resolveUserAccess({
					userInfo,
					subscriptionStatus: subscriptionStatusObject.status,
					planType,
					treePermissions,
				});
				let currentTrees = userInfo.currentTrees ? userInfo.currentTrees : [];
				this.treesRef = base.syncState(`users/${user.uid}/currentTrees`, {
					context: this,
					state: "currentTrees",
					defaultValue: [],
				});
				this.settingsRef = base.syncState(`users/${user.uid}/settings`, {
					context: this,
					state: "settings",
					defaultValue: {
						rtRngLowToHigh: false,
						rtFastDeal: false,
						rtTightHandSelect: false,
						rtOptions: {},
						rtShowPrevFreq: "<100", // "always", "<100", "never"
						rtProportionalDeal: false,
						rtProportionalScenarios: false,
						drdLargeDisplays: false,
						multiTreeSelect: false,
					},
				});

				console.log({
					tier: accessState.tier,
					access: accessState.access,
					userIsVerified: accessState.userIsVerified,
					trialUser: accessState.trialUser,
					trialExpired: accessState.trialExpired,
					trialEnd: accessState.trialEnd,
					modalOpen: accessState.modalOpen,
					userInfo: { name: user.displayName, uid: user.uid, treePermissions: accessState.permissions },
					currentTrees,
					userIsLoggedIn: true,
					loading: false,
				});

				this.setState({
					tier: accessState.tier,
					access: accessState.access,
					userIsVerified: accessState.userIsVerified,
					trialUser: accessState.trialUser,
					trialExpired: accessState.trialExpired,
					trialEnd: accessState.trialEnd,
					modalOpen: accessState.modalOpen,
					userInfo: { name: user.displayName, uid: user.uid, treePermissions: accessState.permissions },
					currentTrees,
					userIsLoggedIn: true,
					loading: false,
				});
			} else {
				this.setState({ loading: false });
			}
		});
	}

	componentWillUnmount() {
		this.treesRef && base.removeBinding(this.treesRef);
		this.settingsRef && base.removeBinding(this.settingsRef);
	}

	//TODO: handleTreeAdd, handleTreeRemove, rework handleTreeChange to function when there is 1 tree in the array
	handleTreeChange = (tree) => this.setState({ currentTree: tree });
	handleTreesChange = (trees) => this.setState({ currentTrees: trees });
	handleSettingsUpdate = (property, value) => {
		const settings = this.state.settings;
		settings[property] = value;
		this.setState({ settings });
	};
	handleSubscriptionStatusUpdate = (status, planType) => {
		this.setState({ subscriptionStatus: status, planType });
		if (planType) base.post(`users/${this.state.userInfo.uid}/planType`, { data: planType });
	};

	logout = async () => {
		await firebase.auth().signOut();
		this.setState(
			{
				userIsLoggedIn: false,
				subscriptionStatus: null,
				access: false,
				tier: null,
				userInfo: {
					name: null,
					uid: null,
					treePermissions: null,
				},
				currentTrees: [],
			},
			() => {
				window.location.href = "/login";
			}
		);
		return true;
	};

	// Dev/Admin functions //

	getUserLastLogin = () => getUserLastLogin(this.state.userInfo.uid);
	getTreeNamesAndIDs = (alphaSort = true) => getTreeNamesAndIDs(this.state.userInfo.uid, alphaSort);
	verifyUser = (userToVerify) => verifyUser(this.state.userInfo.uid, userToVerify);
	verifyBasicUser = (userToBasicify) => verifyBasicUser(this.state.userInfo.uid, userToBasicify);
	addTreeToUser = (user, treeID, treeName) => addTreeToUser(this.state.userInfo.uid, user, treeID, treeName);
	removeTreeFromUser = (user, treeID) => removeTreeFromUser(this.state.userInfo.uid, user, treeID);
	deleteTree = (treeID, deleteReps = false, trackDeletion = true) => deleteTree(this.state.userInfo.uid, treeID, deleteReps, trackDeletion);

	// ------------------ //

	render() {
		// window.dpm = this;
		if (this.state.loading) return <Loading />;
		if (!this.state.userIsLoggedIn) {
			return (
				<Router>
					<Splash />
				</Router>
			);
		}
		return (
			<Router>
				<UserContext.Provider
					value={{
						...this.state.userInfo,
						currentTrees: this.state.currentTrees,
						handleTreeChange: this.handleTreeChange,
						handleTreesChange: this.handleTreesChange,
						settings: this.state.settings,
						handleSettingsUpdate: this.handleSettingsUpdate,
						access: this.state.access,
						handleSubscriptionStatusUpdate: this.handleSubscriptionStatusUpdate,
					}}>
					<div id="body-container">
						<NavBar logout={this.logout} subscriptionStatus={this.state.subscriptionStatus} />
						{/* <SideBar /> */}
						<TrialModal
							open={this.state.modalOpen}
							trialStatus={this.state.trialExpired ? "expired" : "active"}
							trialEnd={this.state.trialEnd}
							closeModal={() => this.setState({ modalOpen: false })}
						/>
						<div id="main-content">
							<Switch>
								<Route exact path="/">
									<RangeTrainer />
								</Route>
								<Route path="/trainer">
									<RangeTrainer />
								</Route>
								<Route path="/drd">
									<DRD />
								</Route>
								<Route path="/ranges">
									<DRD />
								</Route>
								<Route path="/upload">
									<Upload />
								</Route>
								<Route path="/data">
									<TrainingData />
								</Route>

								<Route path="/feedback">
									<Feedback />
								</Route>
								<Route path="/settings">
									<Settings />
								</Route>
								<Route path="/my-account">
									<MyAccount subscriptionStatus={this.state.subscriptionStatus} />
								</Route>
								<Redirect from="/manage-sub" to="/my-account" />
								<Route path="/login">
									<Splash />
								</Route>
								<Route path="/sign-up">
									<Splash />
								</Route>
								<Route path="/signup">
									<Splash />
								</Route>
								<Route path="/subscribe">
									<Subscribe />
								</Route>
								<Route path="/plan">
									<Subscribe />
								</Route>
								<Route path="/success">
									<SubscribeSuccess />
								</Route>
							</Switch>
						</div>
					</div>
				</UserContext.Provider>
			</Router>
		);
	}
}

export default App;
